(function () {
  var cartImages = $('.uploadcare-cart-image-url');
  if (cartImages.length > 0) {
    new LuminousGallery(
      cartImages,
      {
        arrowNavigation: false,
      },
      {
        closeOnScroll: true,
      }
    );
  }
})()